import { otmsHttp } from '@/utils/http/index';

/**
 * 创建流程节点配置
 * YAPI:https://yapi.ops.yunlizhi.cn/project/571/interface/api/22229
 */
export function processRuleCreate(data, params) {
  return otmsHttp.post('/cms_plus/process_rule/create', data, { params });
}

/**
 * 修改流程节点配置
 * YAPI:https://yapi.ops.yunlizhi.cn/project/571/interface/api/22231
 */
export function processRuleUpdate(data, params) {
  return otmsHttp.post('/cms_plus/process_rule/update', data, { params });
}

/**
 * 流程配置详情
 * YAPI:https://yapi.ops.yunlizhi.cn/project/571/interface/api/22233
 */
export function processRuleDetail(data, params) {
  return otmsHttp.post('/cms_plus/process_rule/detail/list', data, { params });
}

/**
 * 创建或更新流程
 * YAPI:https://yapi.ops.yunlizhi.cn/project/571/interface/api/22279
 */
export function processUpsert(data, params) {
  return otmsHttp.post('/cms_plus/process/upsert', data, { params });
}

/**
 * 流程分页查询
 * YAPI:https://yapi.ops.yunlizhi.cn/project/571/interface/api/22283
 */
export function processPage(data, params) {
  return otmsHttp.post('/cms_plus/process/page', data, { params });
}

/**
 * 流程状态更新
 * YAPI:https://yapi.ops.yunlizhi.cn/project/571/interface/api/22281
 */
export function processStatusUpdate(data, params) {
  return otmsHttp.post('/cms_plus/process/status/update', data, { params });
}

/**
 * 全局配置项获取
 */
export function configList(data, params) {
  return otmsHttp.post('/bfs_config/admin/config/list', data, { params });
}
